module.exports = __webpack_public_path__ + "img/d.9521f234.jpg";